/* eslint-disable no-unused-vars */
import "./header.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BsBell } from "react-icons/bs";
import { IoIosArrowDown } from "react-icons/io";
import Avatar from "../../assets/Avatar.png";
import { FiSearch, FiX } from "react-icons/fi";
import TokenService from "../../services/token.service";
import { useAppContext } from "../../context/AppContext";

function Header({ user }) {
	const {
		allEventData,
		setFilteredEventData,
		setResetStatusToggle,
		resetSearchBar,
		setResetSearchBar,
	} = useAppContext();
	const navigate = useNavigate();
	const [count, setCount] = useState(0);
	const [open, setOpen] = useState(false);
	const [searchValue, setSearchValue] = useState("");

	const toggleHeaderDropdown = () => {
		setOpen(!open);
	};

	// Handle Logout
	const handleLogout = () => {
		TokenService.clearStorage();
		navigate("/");
	};

	// Reset Search Bar:
	useEffect(() => {
		if (resetSearchBar) {
			setSearchValue("");
		}
	}, [resetSearchBar]);

	// Search for requests:
	const handleSearch = (e) => {
		const searchTerm = e.target.value;
		setSearchValue(searchTerm);
		const filteredData = allEventData.filter((data) => {
			return (
				data.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
				data.status.toLowerCase().includes(searchTerm.toLowerCase())
			);
		});

		setFilteredEventData(filteredData);

		setResetSearchBar(false);
		setResetStatusToggle(true);
	};

	// Reset Search
	const handleResetSearch = () => {
		setSearchValue("");
		setFilteredEventData(allEventData);
	};

	return (
		<>
			<header className="header">
				<div className="header_items">
					<div className="header_search_bar">
						<span>
							<FiSearch className="header_search_icon" />
							<input
								type="text"
								placeholder="Search"
								className="header_search_input"
								name="search"
								value={searchValue}
								onChange={handleSearch}
							/>
							{searchValue?.length ? (
								<FiX
									className="header_cancel_search_icon"
									onClick={handleResetSearch}
								/>
							) : null}
						</span>
					</div>

					<div className="header_notification">
						<div
							className="header_bell_div"
							// onClick={handleNotifications}
						>
							{count === 0 ? null : (
								<div className="header_notification_count">
									<p>{count}</p>
								</div>
							)}
							{count === 0 ? (
								<BsBell className="header_bell_icon_inactive" />
							) : (
								<BsBell className="header_bell_icon_active" />
							)}
							<IoIosArrowDown
								className={`header_dropdown_icon ${open ? "open" : "closed"}`}
								onClick={toggleHeaderDropdown}
							/>
						</div>
						<div className="header_profile_div">
							<img src={Avatar} alt="Profile picture" />
							<div className="header_profile_info">
								<p>{user}</p>
							</div>
						</div>
					</div>

					<span className={`header_logout ${open ? "open" : "closed"}`}>
						<p onClick={handleLogout}>Logout</p>
					</span>
				</div>
			</header>
		</>
	);
}

export default Header;
